export default "__VITE_ASSET__da3426a3__"